import { createFileRoute } from '@tanstack/react-router';
import { CreateAccountPage } from '../components/pages/CreateAccountPage/CreateAccountPage';

export const Route = createFileRoute('/account/accounts_/create')({
  component: CreateAccountPage,
});
